import { CartService, CartServiceModule } from '@b2b/common/services';
import { AddressService, AddressServiceModule } from '@b2b/common/services/address';
import { CartMembershipsServiceModule } from '@b2b/common/services/cart/memberships/memberships.service';
import { VCardModalControllerModule } from '@b2b/common/views/modals/vcard/controllers/VcardModalController';
import { Address } from '@b2b/types/core';
import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

CardholdersController.$inject = [
  '$scope',
  '$state',
  '$window',
  '$uibModal',
  '$timeout',
  'ApiService',
  'CartService',
  'AddressService',
  'CalendarService',
  'GridStateFactory',
  'GridDefinitionFactory',
  '$filter',
  'HelpersService',
];

function CardholdersController(
  $scope,
  $state,
  $window,
  $uibModal,
  $timeout,
  ApiService,
  CartService: CartService,
  AddressService: AddressService,
  CalendarService,
  GridStateFactory,
  GridDefinitionFactory,
  $filter,
  HelpersService
) {
  const ctrl = {
    model: {} as Partial<{ cardHolder: any }>,

    editCardholderModel: false,
    addreses: [],

    dupes: {},
    dedupeSelections: [] as any[],
    memberships: [],

    gridName: $state.current.name + '.grid0',
    gridState: new GridStateFactory(),
    gridDefinition: new GridDefinitionFactory(),
    viewId: '',

    selectedMember: false,
    addresses: [],

    searchCustomer: {
      firstName: '',
      middleName: '',
      lastName: '',
      email: '',
      phone: '',
      address: {
        streetAddress1: '',
        streetAddress2: '',
        city: '',
        state: '',
        country: '',
      },
    },

    showMatches: true,
    showSearchCustomer: true,
    showDuplicatesList: true,
    showReviewInformationForm: false,
    showEditCardholder: false,

    cartService: CartService,

    optionsOverride: {
      data: 'cardholders.dedupeSelections',
      useAccessibleGrid: true,
      enableSorting: true,
      showEmpty: true,
      enablePagination: false,
      showGridFooter: false,
      rowClasses: "{ 'ui-grid-row-header-cell': col.isRowHeader }",
      appScopeProvider: {
        onDataGridPaginate: function (newPageNumber, newPageSize) {
          // $scope.retailMemberships.onDataGridPaginate(newPageNumber, newPageSize);
        },
        onDataGridSortChange: function (grid, columns, page) {
          // $scope.retailMemberships.onDataGridSortChange(grid, columns, page);
        },
        onDataGridSelectionChange: function (row, e) {
          ctrl.onDataGridSelectionChange(row, e);
        },
        viewDetail: function (item) {
          // $scope.retailMemberships.viewDetail(item);
        },
      },
      columnDefs: [
        {
          field: 'type',
          displayName: '',
          enableHiding: false,
          enableSorting: false,
          cellTemplate:
            '<div><div data-ng-if="row.groupHeader" class="ui-grid-cell-contents" title="TOOLTIP">{{COL_FIELD CUSTOM_FILTERS}}</div></div>',
          visible: false,
        },
        {
          field: 'title',
          displayName: 'Title',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'firstName',
          displayName: 'First Name',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'middleName',
          displayName: 'Middle',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'lastName',
          displayName: 'Last Name',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'email',
          displayName: 'Email',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'phone',
          displayName: 'Phone',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'flatAddress',
          displayName: 'Address',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'memberships[0].gridDisplay.level',
          displayName: 'Level',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'memberships[0].gridDisplay.membershipStanding',
          displayName: 'Standing',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'memberships[0].gridDisplay.expiration',
          displayName: 'Expiration',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'memberships[0].gridDisplay.membershipId',
          displayName: 'Membership Id',
          headerTooltip: true,
          visible: true,
        },
      ],
    },

    init: function () {
      $scope.$emit('Application::contentTitleChange', {
        title: 'Add Cardholder',
        buttonLeft: {
          label: '< Checkout',
          action: function () {
            ctrl.gotoCheckout();
          },
        },
      });

      this.initMemberships();
      this.initDupes();
      this.initGrid();

      $scope.$on('VcardCardholder::Complete', this.done);
    },

    initMemberships: function () {
      if (this.cartService.memberships.hasOwnProperty('getModel')) {
        this.memberships = this.cartService.memberships.getModel();
      }
    },

    initDupes: function () {
      const dupes = this.getDupes();
      // getDupes returns Array<{ customer, possibleDuplcates }> now
      this.dupes = dupes && dupes instanceof Array ? dupes[0] : false;

      if (this.dupes && this.dupes.hasOwnProperty('possibleDuplicates')) {
        this.model = this.getCardholderInfo();
        this.dedupeSelections = this.getDedupeSelections();
        this.showSearchCustomer = false;
      } else {
        this.showSearchCustomer = true;
        this.showMatches = false;
      }
    },

    initGrid: function () {
      this.viewId = $state.current.name;
      this.gridDefinition.init(this.gridName, this.optionsOverride, this.viewId, false);
      this.gridDefinition.isLoaded = true;

      $timeout(function () {
        $scope.$broadcast('DataGrid::ResizeGrid', {
          name: ctrl.gridDefinition.options.gridName,
          datasetLength: ctrl.dedupeSelections.length,
          totalItems: ctrl.dedupeSelections.length,
        });
      }, 10);
    },

    editCardholder: function () {
      this.editCardholderModel = Object.assign({}, this.model.cardHolder);
      this.editCardholderModel.addresses = this.editCardholderModel.address ? [this.editCardholderModel.address] : [];
      this.showEditCardholder = true;
    },

    saveEditCardholder: function () {
      $scope.$broadcast('VcardCardholder::Process');
    },

    cancelEditCardholder: function () {
      this.showEditCardholder = false;
      this.editCardholderModel = false;
    },

    search: function () {
      ApiService.dedupe.list(this.searchCustomer).then(this.success.search, this.error.search);
    },

    getDupes: function () {
      if (this.cartService.memberships.hasOwnProperty('getCustomerDuplicates')) {
        return this.cartService.memberships.getCustomerDuplicates();
      }
    },

    getCardholderInfo: function () {
      if (this.cartService.memberships.hasOwnProperty('getCardholderInfo')) {
        return this.cartService.memberships.getCardholderInfo();
      }
    },

    getMembershipCartData: function () {
      if (this.cartService.memberships.hasOwnProperty('getMembershipCartData')) {
        return this.cartService.memberships.getMembershipCartData();
      }
    },

    clear: function () {
      this.cartService.memberships.clearCustomerData();
    },

    getDedupeSelections: function (possibleDuplicates: any[]) {
      const result: any[] = [];
      const duplicates = possibleDuplicates || this.dupes.possibleDuplicates;

      angular.forEach(duplicates, function (dupe) {
        const p: {
          customerId: string;
          firstName: string;
          middleName: string;
          lastName: string;
          email: string;
          flatAddress?: string;
          address?: Address;
          memberships?: any[];
        } = {
          customerId: dupe.id,
          firstName: dupe.firstName,
          middleName: dupe.middleName,
          lastName: dupe.lastName,
          email: dupe.email,
        };

        if (dupe.address instanceof Array && dupe.address.length > 0) {
          const address = dupe.address[0];
          p.flatAddress = AddressService.getFormattedAddress(address).name;
          p.address = address;
        }

        // Grab the first active membership, or the first membership we find otherwise
        if (dupe.memberships instanceof Array && dupe.memberships.length > 0) {
          let adjustFirstLevelName = dupe.memberships.length > 1;
          p.memberships = dupe.memberships.map(function (membership) {
            // Show a '+ mpre' in the grid when they have more than one membership
            const gridDisplay = {
              level: adjustFirstLevelName ? membership.membershipCategory + ' + more' : membership.membershipCategory,
              membershipStanding: adjustFirstLevelName ? 'Various' : membership.membershipStanding,
              expiration: adjustFirstLevelName
                ? 'Various'
                : $filter('date')(
                    CalendarService.parseDate(membership.membershipExpirationDate),
                    HelpersService.dateFormats.sortDate
                  ),
              membershipId: adjustFirstLevelName ? 'Various' : membership.importId,
            };
            adjustFirstLevelName = false;

            return {
              gridDisplay: gridDisplay,
              level: membership.membershipCategory,
              membershipStanding: membership.membershipStanding,
              expiration: $filter('date')(
                CalendarService.parseDate(membership.membershipExpirationDate),
                HelpersService.dateFormats.sortDate
              ),
              membershipId: membership.importId,
              nameOnCard: membership.cardholders[0].name,
            };
          });
        } else {
          p.memberships = [];
        }

        result.push(p);
      });

      return result;
    },

    gotoCheckout: function () {
      ctrl.clear();
      $state.go('application.cart');
    },

    continueAndReview: function () {
      this.showDuplicatesList = false;
      this.showReviewInformationForm = true;
      this.selectedMember.addresses = this.selectedMember.address ? [this.selectedMember.address] : [];
      this.selectedMember.cardType = this.model.cardHolder?.cardType;
      this.selectedMember.showCardType = 'customer';
      this.selectedMember.name = [this.selectedMember.firstName, this.selectedMember.lastName].join(' ');
    },

    save: function () {
      $scope.$broadcast('VcardCardholder::Process');
    },

    done: function () {
      ctrl.updateCardholder();
    },

    updateCardholder: function () {
      const cardholder = this.editCardholderModel || this.selectedMember;

      this.memberships = this.cartService.memberships.getModel();

      for (let mIndex = 0; mIndex < this.memberships.length; mIndex++) {
        const membership = this.memberships[mIndex];
        for (let cIndex = 0; cIndex < membership.membershipInfo.membershipCards.length; cIndex++) {
          const card = membership.membershipInfo.membershipCards[cIndex];
          if (
            this.model.cardHolder.cardType === card.cardType &&
            this.model.cardHolder.firstName === card.firstName &&
            this.model.cardHolder.lastName === card.lastName
          ) {
            if (cardholder.prefix) {
              this.memberships[mIndex].membershipInfo.membershipCards[cIndex].prefix = cardholder.prefix;
            }

            if (cardholder.firstName) {
              this.memberships[mIndex].membershipInfo.membershipCards[cIndex].firstName = cardholder.firstName;
            }

            if (cardholder.middleName) {
              this.memberships[mIndex].membershipInfo.membershipCards[cIndex].middleName = cardholder.middleName;
            }

            if (cardholder.lastName) {
              this.memberships[mIndex].membershipInfo.membershipCards[cIndex].lastName = cardholder.lastName;
            }

            if (cardholder.name) {
              this.memberships[mIndex].membershipInfo.membershipCards[cIndex].name = cardholder.name;
            }

            if (cardholder.email) {
              this.memberships[mIndex].membershipInfo.membershipCards[cIndex].email = cardholder.email;
            }

            if (cardholder.phoneNumber) {
              this.memberships[mIndex].membershipInfo.membershipCards[cIndex].phoneNumber = cardholder.phoneNumber;
            }

            this.memberships[mIndex].membershipInfo.membershipCards[cIndex].address = cardholder.address;
          }
        }
      }

      if (this.editCardholderModel) {
        this.cartService.updateCart().then(this.success.updateCartAndContinue, this.error.updateCartAndContinue);
      } else {
        this.cartService.updateCart().then(this.success.updateCart, this.error.updateCart);
      }
    },

    success: {
      init: function (response) {},
      updateCart: function (response) {
        ctrl.gotoCheckout();
      },
      updateCartAndContinue: function () {
        ctrl.model.cardHolder = Object.assign({}, ctrl.editCardholderModel);
        ctrl.editCardholderModel = false;
        ctrl.showEditCardholder = false;
        ApiService.dedupe.list(ctrl.model.cardHolder).then(ctrl.success.search, ctrl.error.search);
      },
      search: function (response) {
        ctrl.dedupeSelections = ctrl.getDedupeSelections(response.data.payload[0].possibleDuplicates);
        ctrl.showMatches = true;
        $timeout(function () {
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: ctrl.gridDefinition.options.gridName,
            datasetLength: ctrl.dedupeSelections.length,
            totalItems: ctrl.dedupeSelections.length,
          });
        }, 10);
      },
    },

    error: {
      init: function (response) {},
      updateCart: function (response) {},
      updateCartAndContinue: function (response) {},
      search: function (response) {
        console.log(response);
      },
    },

    // TODO
    onDataGridSelectionChange: function (row, e) {
      if (row.isSelected) {
        ctrl.selectedMember = row.entity;
      } else {
        ctrl.selectedMember = false;
      }
    },
  };

  $scope.cardholders = ctrl;
  ctrl.init();
}

export const CardholdersControllerModule = angular
  .module('acme.view.application.cardholders.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    CartServiceModule,
    CartMembershipsServiceModule,
    AddressServiceModule,
    'acme.common.service.calendar',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    VCardModalControllerModule,
  ])
  .controller('CardholdersController', CardholdersController).name;
